module.exports = __webpack_public_path__ + "static/media/chrome.fa9c6521.png";